import { ErrorPage } from "./error-page";
import { attemptReloadOnChunkError } from "@/shared/lib/lazy-with-reload";

type Props = {
  // The router passes whatever was thrown, typed `unknown` since @tanstack/react-router 1.170.46.
  error: unknown;
};

export const ErrorHandler = ({ error: thrown }: Props) => {
  const error = thrown instanceof Error ? thrown : new Error(String(thrown));

  // Returns null only when a reload was actually triggered; persistent chunk
  // failures (guard already burned) fall through to the regular error UI.
  if (attemptReloadOnChunkError(error)) return null;

  // Check by error name instead of instanceof
  if (error.name === "EntityBadRequestError") {
    return <ErrorPage error={error} statusCode={400} />;
  }

  if (error.name === "UnauthorizedError") {
    return <ErrorPage error={error} statusCode={401} />;
  }

  if (error.name === "EntityNotFoundError") {
    return <ErrorPage error={error} statusCode={404} />;
  }

  return <ErrorPage error={error} statusCode={500} />;
};
